// extracted by mini-css-extract-plugin
export default {"headerBox":"index_headerBox_gHVxL","container":"index_container_XirB7","searchBox":"index_searchBox_VY12I"};